<template>
  <div v-if="mandatoryDataPresent">
    <form
      v-if="!disabled"
      ref="eventEquipeLoginForm"
      :action="
        equipeAuthData.apiUrl +
        '/federations/' +
        equipeAuthData.federationId +
        '/auth'
      "
      method="post"
      target="_blank"
    >
      <input
        :value="equipeAuthData.organizerId"
        type="hidden"
        name="organizer_id"
      />
      <input
        :value="equipeAuthData.organizerName"
        type="hidden"
        name="organizer_name"
      />
      <input :value="equipeAuthData.name" type="hidden" name="name" />
      <input :value="equipeAuthData.email" type="hidden" name="email" />
      <input
        :value="equipeAuthData.cellPhone"
        type="hidden"
        name="cell_phone"
      />
      <input :value="equipeAuthData.locale" type="hidden" name="locale" />
      <input
        :value="equipeAuthData.authToken"
        type="hidden"
        name="auth_token"
      />
    </form>
    <v-tooltip location="bottom">
      <template #activator="{ props }">
        <span v-bind="props">
          <v-btn
            class="fixed-v-btn elevation-1 mb-2"
            variant="outlined"
            :style="styleProps"
            :disabled="disabled"
            color="edit"
            v-bind="$attrs"
            @click="$refs.eventEquipeLoginForm.submit()"
          >
            {{
              $t(
                "events:EventCardLarge.Actions.Equipe.button",
                "Equipe",
                " Equipe button in event page"
              )
            }}
          </v-btn>
        </span>
      </template>
      <span>
        <template v-if="disabled">
          {{
            $t(
              "events:EventCardLarge.Actions.EquipeNotActive.tooltip",
              "Equipe service will be activated after registration is closed.",
              "Tooltip for Equipe button in event page"
            )
          }}
        </template>
        <template v-else>
          {{
            $t(
              "events:EventCardLarge.Actions.Equipe.tooltip",
              "Log in to Equipe APP",
              "Tooltip for Equipe button in event page"
            )
          }}
        </template>
      </span>
    </v-tooltip>
  </div>
</template>
<script>
import gql from "fraql";
export const APP_EQUIPE_BTN_GQL = gql`
  fragment _ on EquipeAuthData {
    apiUrl
    federationId
    organizerId
    organizerName
    name
    email
    cellPhone
    locale
    authToken
  }
`;
export default {
  name: "AppEquipeBtn",
  props: {
    equipeAuthData: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    styleProps: {
      type: String,
      default: null
    }
  },
  computed: {
    mandatoryDataPresent() {
      if (this.equipeAuthData) {
        const { apiUrl, federationId, organizerId, email, authToken } =
          this.equipeAuthData;
        return apiUrl && federationId && organizerId && email && authToken;
      }
      return false;
    }
  },
  fragments: {
    equipeAuthData: APP_EQUIPE_BTN_GQL
  }
};
</script>
